module.exports = __webpack_public_path__ + "static/dashboard@2x-410396bb2f01a09ba2b53ae7877bbe4b.webp";